import listenForDtmfOnVoiceCallContent from './listenForDtmfOnVoiceCallContent';

const DEFAULT_MAX = 6;
const MIN_MAX = 1;
const MAX_MAX = 12;

const normalizeMaximumAllowed = value => {
  const parsed = Number(value);
  return Number.isInteger(parsed) ? parsed : NaN;
};

const listenForDtmfOnVoiceCall = {
  name: 'Listen for DTMF on Voice Call',
  Content: listenForDtmfOnVoiceCallContent,
  setInitialContent: (content = {}) => ({
    maximumAllowed:
      content.maximumAllowed ?? DEFAULT_MAX
  }),
  valid: content => {
    const maximumAllowed = normalizeMaximumAllowed(
      content.maximumAllowed
    );

    return (
      Number.isInteger(maximumAllowed) &&
      maximumAllowed >= MIN_MAX &&
      maximumAllowed <= MAX_MAX
    );
  }
};

export default listenForDtmfOnVoiceCall;